import React, { useState, useEffect } from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useParams } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const View_Cat_Packing = () => {
    const [items, setItems] = useState([]);
    const [addons, setAddons] = useState([]);
    const [order, setOrder] = useState(null);

    const { sno } = useParams();
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;

    // Fetch order data
    useEffect(() => {
        const fetchOrder = async () => {
            if (!sno) return;

            try {
                const res = await axios.get(`${BaseUrl}/catering-packing-item-view/${sno}`, {
                    params: { branch_id }
                });

                if (!res.data?.data) {
                    toast.info("Order not found");
                    setOrder(null);
                    setItems([]);
                    setAddons([]);
                    return;
                }

                const orderData = res.data.data;
                setOrder(orderData);
                setItems(orderData.item_list || []);
                setAddons(orderData.addons_list || []);
            } catch (err) {
                console.error("Failed to fetch order details:", err);
                toast.error("Failed to fetch order details");
            }
        };
        fetchOrder();
    }, [sno, branch_id, BaseUrl]);

    const getMeasurementUnit = (item) => {
        switch (item.measurement_quantity) {
            case 1:
            case 2: return "kgs";
            case 3:
            case 4: return "ltrs";
            case 5: return "no's";
            default: return "Units";
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    if (!order) return <div>Loading...</div>;

    // Handle drag end for vessels
    const onDragEnd = (result, itemId) => {
        if (!result.destination) return;

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        setItems(prevItems => prevItems.map(item => {
            if (item.id === itemId) {
                const newVessels = Array.from(item.vessels_list);
                const [removed] = newVessels.splice(sourceIndex, 1);
                newVessels.splice(destinationIndex, 0, removed);
                return { ...item, vessels_list: newVessels };
            }
            return item;
        }));
    };

    return (
        <>
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>View Catering Packing</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Packing</li>
                    </ol>
                </div>
                <div className='d-flex flex-column align-items-center justify-content-center gap-1'>
                    <Badge bg='primary' className='text-white rounded font-w500 fs-7'>
                        {order.packing_status_text}
                    </Badge>
                    <OverlayTrigger
                        trigger="hover"
                        placement="bottom"
                        overlay={<Tooltip><span className='fs-8 text-white fw-semibold'>Dispatched Date</span></Tooltip>}
                    >
                        <label className='text-danger font-w500 fs-7'>{order.packing_date}</label>
                    </OverlayTrigger>
                </div>
            </div>

            {/* Main Content */}
            <div className='row mb-2'>
                {/* Order Details */}
                <div className="col-lg-3 col-md-4 col-sm-2 mb-2 px-4 py-4 mx-4" style={{ borderRight: '1px solid #bebebeff' }}>
                    <div className='row'>
                        <div className='col-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Customer Name</label>
                            <label className='text-primary fs-6 font-w600'>{order.customer_name ?? ""}</label>
                        </div>
                        <div className='col-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Customer Mobile No</label>
                            <label className='text-primary fs-6 font-w600'>{order.customer_number ?? ""}</label>
                        </div>
                        <div className='col-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Order Id</label>
                            <label className='text-primary fs-6 font-w600'>{order.packing_order_id ?? ""}</label>
                        </div>
                        <div className='col-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Delivery Date/ Time</label>
                            <label className='text-primary fs-6 font-w600'>{formatDate(order.packing_date)}</label>
                        </div>
                        <div className='col-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Delivery Address</label>
                            <label className='text-primary fs-6 font-w600'>{order.delivery_address ?? ""}</label>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
                            <label className='text-black font-w600 fs-7'>Total Items</label>
                            <Badge bg="primary" className='text-white fs-6 px-3 py-0'>{items.length}</Badge>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
                            <label className='text-black font-w600 fs-7'>Total Add-On's</label>
                            <Badge bg="primary" className='text-white fs-6 px-3 py-0'>{addons.length}</Badge>
                        </div>
                    </div>
                </div>

                {/* Items & Add-Ons */}
                <div className='col-lg-8 mb-2'>
                    <div className='row'>
                        {/* Items Table */}
                        <div className='col-12 mb-2'>
                            <label className='text-red font-w600 fs-4 mb-2'>Items Packing</label>
                            <div className="scroll-y" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                {Array.isArray(items) && items.length > 0 ? (
                                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                                        style={{ borderBottom: '2px solid #ddd' }}>
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th>Packed</th>
                                                <th>Item</th>
                                                <th className="text-center">Total Qty</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {items.map(item => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <div className="form-check custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input me-3"
                                                                id={`customCheckBox${item.id}`}
                                                                checked={item.item_list_status !== 0}
                                                                disabled
                                                            />
                                                        </div>
                                                    </td>

                                                    <td className='text-black'>{item.item_name}</td>

                                                    <td className="text-center text-black">
                                                        {item.quantity} {getMeasurementUnit(item)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p>No items found.</p>
                                )}
                            </div>
                        </div>

                        {items.some(row => row.vessels_list?.length > 0) && (
                            <div className='col-12 mb-2'>
                                <h5 className="text-black font-w600 mb-3 fs-4">Selected Vessels</h5>

                                <div className="p-4 rounded"
                                    style={{ backgroundColor: '#f0f5ef', maxHeight: '300px', overflowY: 'auto' }}>

                                    {items.map(row =>
                                        row.vessels_list?.length > 0 && (
                                            <div key={row.id} className="mb-2">
                                                <h5 className="text-black font-w600 mb-3 fs-4">
                                                    {row.item_name} - Selected Vessels
                                                </h5>

                                                <div className="d-flex flex-wrap gap-2" style={{ rowGap: "15px" }}>
                                                    {row.vessels_list.map((v, idx) => (
                                                        <div key={idx}
                                                            className="p-3 rounded shadow-sm bg-white"
                                                            style={{ width: "calc(25% - 10px)", border: "1px solid #e0e0e0" }}>

                                                            <div className="fw-bold text-black fs-6">
                                                                {v?.name ?? "-"}
                                                            </div>

                                                            <div className="fs-6 text-black mt-1">
                                                                {v.count} No's
                                                            </div>

                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Add-Ons Table */}
                        {addons.length > 0 && (
                            <div className='col-12 mb-2'>
                                <label className='text-red font-w600 fs-4 mb-2'>Add-On's Checklist</label>
                                <div className="scroll-y" style={{ maxHeight: "300px" }}>
                                    {addons.length ? (
                                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th>Selected</th>
                                                    <th>Add-On's</th>
                                                    <th className="text-center">Total Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {addons.map(addon => (
                                                    <tr key={addon.id}>
                                                        <td>
                                                            <div className="form-check custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input me-3"
                                                                    id={`customCheckBox${addon.id}`}
                                                                    checked={addon.status !== 0}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className='text-black'>{addon.service_name}</td>
                                                        <td className="text-center text-black">{addon.quantity}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : <p>No add-on services found.</p>}
                                </div>
                            </div>
                        )}

                        {/* Assigned Vehicle & Staff */}
                        {(order.assigned_vehicle_name || order.assigned_staff_name) && (
                            <div className='col-12 mb-2'>
                                <label className='text-red font-w600 fs-4 mb-2'>Allotted Vehicles / Staff</label>
                                <div className='row'>
                                    {order.assigned_vehicle_name && (
                                        <div className="col-lg-4 mb-2">
                                            <label className="text-black font-w600 fs-6">Vehicle</label>
                                            <div className="text-primary fs-7">{order.assigned_vehicle_name}</div>
                                        </div>
                                    )}
                                    {order.assigned_staff_name && (
                                        <div className="col-lg-4 mb-2">
                                            <label className="text-black font-w600 fs-6">Staff</label>
                                            <div className="text-primary fs-7">{order.assigned_staff_name}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default View_Cat_Packing;
